import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'

function ReachBarChart({ width, height, left, top, data, reversed = false }) {
    const [ratings, setRatings] = useState(
        [
            {
                "name": "Very Weak (1)",
            },
            {
                "name": "Weak (2)",
            },
            {
                "name": "Good (3)",
            },
            {
                "name": "Very Good (4)",
            },
            {
                "name": "Excellent (5)",
            }
        ]
    )
    useEffect(() => {
        // console.log(data, 'bar chart')
        if (data) {
            setRatings(data.map((x, i) => {
                return {
                    ...x,
                    'x_render': `${x.label?.substring(0, x.label?.indexOf('_'))} star${((reversed ? 5 - i : i + 1) !== 1) ? 's' : ''} `
                }
            }))
        }
    }, [data, reversed])

    return (
        <ResponsiveContainer width={700} height={256}>
            <BarChart width={width || 730} height={height || '256px'}
                data={ratings} 
                style={{ marginLeft:'-40px',  }}
                // className={` ${left || 'left-0'} ${top || 'top-[60%]'}`}
                >
                <CartesianGrid />
                <XAxis dataKey="x_render" reversed={reversed} />
                <YAxis dataKey={'value'} />
                <Tooltip cursor={false} />
                {/* <Legend /> */}
                <Bar
                    dataKey="value" fill="#1976D2" className='rounded-[6px] border p-2' width={150} radius={6} barSize={70}
                    isAnimationActive={false} />
            </BarChart>
        </ResponsiveContainer>
    )
}
export default ReachBarChart                 
